import { FieldInputProps, FormikProps } from 'formik';
import React from 'react';
import { OutlinedTextField } from '../../../InputFields';
import { OutlinedTextFieldProps } from '../../../InputFields/types';
import callHandlers from '../callHandlers';

type ExcludeProps = 'onChange' | 'value';

type Props<FormValues> = Omit<OutlinedTextFieldProps, ExcludeProps> & {
    field: FieldInputProps<string>,
    form: FormikProps<FormValues>,
    onChangeHandlers?: Array<string>,
    onBlurHandlers?: Array<string>,
    actionHandlers?: Record<string, (newValue: string, fieldName: string) => void>,
};

const FormikTextField = <FormValues extends {}>(props: Props<FormValues>) => {
    console.log('formik-text-field', props);
    const {
        form,
        field,
        onChangeHandlers,
        onBlurHandlers,
        actionHandlers,
        ...otherProps
    } = props;
    const { getFieldMeta } = form;
    const {
        name,
        value,
        onChange,
        onBlur,
    } = field;
    const { error } = getFieldMeta(name);

    const handleChange = (
        newValue: string,
        event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    ) => {
        onChange(event);
        callHandlers(newValue, name, onChangeHandlers, actionHandlers);
    };

    const handleBlur = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onBlur(event);
        callHandlers(value, name, onBlurHandlers, actionHandlers);
    };
    return (
        <OutlinedTextField
            name={name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={value}
            error={Boolean(error)}
            helperText={error}
            {...otherProps}
        />
    );
};

FormikTextField.defaultProps = {
    onChangeHandlers: null,
    actionHandlers: null,
    onBlurHandlers: null,
};

export default FormikTextField;
